const overloading = {
  breakpointNames: ['sm', 'md', 'lg', 'xl', 'xxl'],
  breakpoints: [576, 768, 992, 1200, 1600]
}

const colors = {
  greenColor : '#166c75',
  tiffanyGreenColor : '#43c0b4',
  waterGreenColor : '#7fb4b9'
}

const variables = {
  familyBase: '"proxima-nova",sans-serif',
  familyHeader: '"proxima-nova",serif',

  primaryColor: colors.greenColor,
  fontColor: '#404040',
  bgColor: '#ebebeb',

  ...colors,
  ...overloading
}

export default variables;